

















import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { JinroGamePlayinfoDocument } from "@/services/datatypes";
import JinroGame from "../JinroPlayer/JinroGame.vue";
import { JinroPlayStatus } from "@/services/jinro-play-status";
import SelectResult from "@/components/shared/SelectResult.vue";
import ChatActivity from "./ChatActivity.vue";
import JinroPlayinfoActivity from "./JinroPlayinfoActivity.vue";

@Component({
  components: {
    SelectResult,
    ChatActivity,
    JinroPlayinfoActivity
  }
})
export default class JinroGameActivities extends Vue {
  @Prop() readonly allActivities!: Array<JinroGamePlayinfoDocument>;

  isDay(playStatus: JinroPlayStatus): boolean {
    return playStatus === JinroPlayStatus.Day;
  }
  isVote(playStatus: JinroPlayStatus): boolean {
    return playStatus === JinroPlayStatus.Vote;
  }
  isExtraVote(playStatus: JinroPlayStatus): boolean {
    return playStatus === JinroPlayStatus.ExtraVote;
  }
  isExecution(playStatus: JinroPlayStatus): boolean {
    return playStatus === JinroPlayStatus.Execution;
  }
  isNight(playStatus: JinroPlayStatus): boolean {
    return playStatus === JinroPlayStatus.Night;
  }
  isEnding(playStatus: JinroPlayStatus): boolean {
    return playStatus === JinroPlayStatus.Ending;
  }

  skipHr(activity: any, index: number): boolean {
    if (activity.type === "chat") {
      if (this.allActivities.length === index + 1) {
        return false;
      }
      const nextActivity: any = this.allActivities[index + 1];
      if (nextActivity.type === "chat") {
        return true;
      }
    }

    const playStatus = activity.playStatus;
    if (!playStatus) {
      return false;
    }

    const skipStatuses = [JinroPlayStatus.Prologue, JinroPlayStatus.AfterNight];
    return skipStatuses.includes(playStatus);
  }
}
